import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name book-key
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAxOS41di0xNUEyLjUgMi41IDAgMCAxIDYuNSAySDE0IiAvPgogIDxwYXRoIGQ9Ik0yMCA4djE0SDYuNWEyLjUgMi41IDAgMCAxIDAtNUgyMCIgLz4KICA8Y2lyY2xlIGN4PSIxNCIgY3k9IjgiIHI9IjIiIC8+CiAgPHBhdGggZD0ibTIwIDItNC41IDQuNSIgLz4KICA8cGF0aCBkPSJtMTkgMyAxIDEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/book-key
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const BookKey: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14' }],
    ['path', { d: 'M20 8v14H6.5a2.5 2.5 0 0 1 0-5H20' }],
    ['circle', { cx: '14', cy: '8', r: '2' }],
    ['path', { d: 'm20 2-4.5 4.5' }],
    ['path', { d: 'm19 3 1 1' }],
  ],
];

export default BookKey;
